module.exports = __webpack_public_path__ + "front/img/83.1294ffbf.jpg";